import { createContext } from "react";

export interface PageTitleContextType {
  pageTitle: string | null;
  setPageTitle: (title: string | null) => void;
}

export const PageTitleContext = createContext<PageTitleContextType | undefined>(
  undefined
);
